
import { useState, createContext } from 'react';
import { Outlet } from 'react-router-dom';
import './App.css';
import Nav from './components/Nav/Nav';
import ThemeBtn from './components/ThemeBtn/ThemeBtn';


export let UserContext = createContext('');

function App() {
  let [theme, setTheme] = useState('synthwave');
  let [user, setUser] = useState('');
  let [exist, setExist] = useState(false);

  return (
    <UserContext.Provider value={{user, setUser, exist, setExist}}>
      <div className="App min-h-screen" data-theme={theme}>
        <div className='max-w-5xl mx-auto'>
          <Nav></Nav>
          <Outlet></Outlet>
          <ThemeBtn setTheme={setTheme} />
        </div>
      </div>
    </UserContext.Provider>
  );
}

export default App;
